
class SocialSharing extends HTMLElement {
  constructor() {
    super();

    const copyToClipboardButton = this.querySelector("[data-copy-to-clipboard]");
    if (!copyToClipboardButton) return; // Early exit if the button isn't present

    const currentLink = copyToClipboardButton.dataset.currentLink;
    const tooltip = copyToClipboardButton.querySelector("[data-copy-to-clipboard-tooltip]");
    const tooltipCopyText = tooltip.dataset.copyToClipboardTooltip;
    const tooltipCopiedText = tooltip.dataset.copiedToClipboardTooltip;

    // Copy link to clipboard on click
    copyToClipboardButton.addEventListener("click", () => {
      navigator.clipboard.writeText(currentLink).then(() => {
        tooltip.innerHTML = tooltipCopiedText;
      }).catch(err => {
        console.error("Failed to copy: ", err);
      });
    });

    // Reset the tooltip on mouseout
    copyToClipboardButton.addEventListener("mouseout", () => {
      tooltip.innerHTML = tooltipCopyText;
    });
  }
}

if (!customElements.get("social-sharing")) {
  customElements.define("social-sharing", SocialSharing);
}
